import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';
import { KeyboardEvent } from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { KeyCode } from '../../../typings/common';
import { ButtonDecorator } from '../../ButtonDecorator/ButtonDecorator';
import { ModalDecorator } from '../../ModalDecorator/ModalDecorator';
import { TextInputDecorator } from '../../TextInputDecorator/TextInputDecorator';

import './FakeAuthModal.css';
import * as keyset from './FakeAuthModal.i18n';

const i18n = i18nFactory(keyset);

export interface FakeAuthModalState {
    text: string;
}

export interface FakeAuthModalProps {
    onAccept: (value: string) => void;
    isVisible: boolean;
    onClose: () => void;
}

export class FakeAuthModal extends React.Component<FakeAuthModalProps, FakeAuthModalState> {
    constructor(props: FakeAuthModalProps) {
        super(props);

        this.state = {
            text: ''
        };
    }

    render() {
        const { text } = this.state;
        const { isVisible, onClose } = this.props;

        return (
            <>
                <ModalDecorator view="classic" theme="normal" visible={isVisible} onOutsideClick={onClose}>
                    <div className={Bem.cls('fake-auth', 'modal-content')}>
                        <p className={Bem.cls('fake-auth', 'modal-title')}>{i18n('title')}</p>
                        <TextInputDecorator
                            theme={'normal'}
                            view={'classic'}
                            text={text}
                            onKeyDown={this.onKeyDown}
                            size={'s'}
                            onChange={this.onTextinputChange}
                        />
                        <div className={Bem.cls('fake-auth', 'buttons')}>
                            <ButtonDecorator
                                theme={'action'}
                                view="default"
                                tone="default"
                                type="submit"
                                size={'n'}
                                text={i18n('accept')}
                                onClick={this.onAccept}
                            />
                            <ButtonDecorator
                                theme={'pseudo'}
                                view="default"
                                tone="default"
                                cls={Bem.cls('fake-auth', 'cancel-button')}
                                size={'n'}
                                text={i18n('cancel')}
                                onClick={onClose}
                            />
                        </div>
                    </div>
                </ModalDecorator>
            </>
        );
    }
    private onTextinputChange = (text: string) => this.setState({ text });
    private onAccept = () => this.props.onAccept(this.state.text);
    private onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.keyCode === KeyCode.RETURN) {
            this.onAccept();
        }
    };
}
